import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { DashboardList, DashboardListItem } from 'src/api/models';
import { DashboardComponent } from 'src/app/views/dashboard/dashboard.component';

import {DashboardListTableService} from 'src/service/dashboard-list.service';
import { DashboardListService } from 'src/api/services/dashboard-list.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';

import * as signalR from '@microsoft/signalr';

@Component({
  selector: "app-dashboard-list",
  templateUrl: "./dashboard-list.component.html",
  styleUrls: ["./dashboard-list.component.css"],
})
export class DashboardListComponent implements OnInit, OnDestroy {
  @ViewChild("embeddedDashboard", { static: false }) embeddedDashboard: DashboardComponent;
  @Input() dashboardListId: number;
  loading:boolean;
  dashboardList: DashboardList;
  dashboardListItem: DashboardListItem;
  showBanner: boolean = true;
  public: boolean = false;

  public connection: signalR.HubConnection;

  
  constructor(
    public authService: AzureAuthService,
    private service: DashboardListService,
    private listService: DashboardListTableService,
    private route: ActivatedRoute,
    private router: Router,
    private toasterService: ToastrService,
    public app: ApplicationConfigService
  ) {
   
  }

  ngOnDestroy(): void {
    
  }


  ngOnInit(): void {
    // Watch DashboardID parameter route change
    this.route.data.subscribe(data => {
      this.public = data["public"] == true;
      //this.embed = data["embed"] == true;
    
      if (this.public){
        this.route.params.subscribe(params => {
          const identifier = params["identifier"];
          const theme = params["theme"];
          if (theme){
            this.app.setTheme(theme);
            //  this.app.theme = theme;
          }
          if (identifier != null){
            console.log('Public List')
            this.getPublicDashboardListById(identifier); 
          }
        });
      }
      else {
        if (this.dashboardListId){
          // Find existing By ID
          this.getDashboardListById(this.dashboardListId);
        } else {
          this.route.params.subscribe(params => {
            const dashboardListId = parseInt(params["dashboardListId"]);
            if (dashboardListId != null){
              this.getDashboardListById(dashboardListId); 
            }
          });
        }
      }
    });
  }

  moveNext(){
    var index = this.dashboardList.dashboards.indexOf(this.dashboardListItem);
    index++;
    if (index == this.dashboardList.dashboards.length){
      index = 0;
    }
    this.dashboardListItem = null;
    this.dashboardListItem = this.dashboardList.dashboards[index];
    if (this.dashboardListItem.displaySeconds == 0){
      this.dashboardListItem.displaySeconds = 60;
    }
    if (this.dashboardListItem.displaySeconds < 15){
      this.dashboardListItem.displaySeconds = 15;
    }
    this.embeddedDashboard.clear();
    this.embeddedDashboard.reload({
      dashboardId:this.dashboardListItem.dashboardId,
      dashboardIdentifier:this.dashboardListItem.dashboardIdentifier,
      displayName:this.dashboardListItem.name,
      siteUri: this.dashboardListItem.siteUri,
      size: null
    });
    console.log("Moving to next dashboard in " + this.dashboardListItem.displaySeconds + " seconds");
    setTimeout(() => {
      // move to the next dashboard item
      this.moveNext();
    }, this.dashboardListItem.displaySeconds * 1000);
  }

  getDashboardListById(id: number): void {
    this.loading = true;
    this.service.DashboardListGetDashboardListToPlay({customerId: this.app.customerId, id: id})
      .subscribe(
        res => {
          console.log(res);
          if (res) {
            this.loading = false;
            this.dashboardList = res;
            if (this.dashboardList.dashboards == null || this.dashboardList.dashboards.length == 0){
              this.toasterService.error("The selected Dashboard List does not contain any Dashboards");
            }else{
              this.dashboardListItem = res.dashboards[0];
            }

            if (this.dashboardList.autoPlay && this.dashboardListItem){
              if (this.dashboardListItem.displaySeconds == 0){
                this.dashboardListItem.displaySeconds = 60;
              }
              if (this.dashboardListItem.displaySeconds < 15){
                this.dashboardListItem.displaySeconds = 15;
              }
              console.log("Moving to next dashboard in " + this.dashboardListItem.displaySeconds + " seconds");
              setTimeout(() => {
                // move to the next dashboard item
                this.moveNext();
              }, this.dashboardListItem.displaySeconds * 1000)
            }

          } else {
            this.toasterService.error("Failed To Find Dashboard List", "Dashboard List");
            this.router.navigate(["/"]);
          }
        },
        err => {
          console.error("ERROR: getDashboardListById", err);
          this.toasterService.error("Failed To Find Dashboard List", "Dashboard List");
          this.router.navigate(["/"]);
        }
      )
  }

  getPublicDashboardListById(id: string): void {
    this.loading = true;
    this.listService.getDashboardList(id)
      .subscribe(
        res => {
          console.log(res);
          if (res) {
            this.loading = false;
            this.dashboardList = res;
            if (this.dashboardList.dashboards == null || this.dashboardList.dashboards.length == 0){
              this.toasterService.error("The selected Dashboard List does not contain any Dashboards");
            }else{
              this.dashboardListItem = res.dashboards[0];
            }

            if (this.dashboardList.autoPlay && this.dashboardListItem){
              if (this.dashboardListItem.displaySeconds == 0){
                this.dashboardListItem.displaySeconds = 60;
              }
              if (this.dashboardListItem.displaySeconds < 15){
                this.dashboardListItem.displaySeconds = 15;
              }
              console.log("Moving to next dashboard in " + this.dashboardListItem.displaySeconds + " seconds");
              setTimeout(() => {
                // move to the next dashboard item
                this.moveNext();
              }, 1000)
            }

          } else {
            this.toasterService.error("Failed To Find Dashboard List", "Dashboard List");
            //this.router.navigate(["/"]);
          }
        },
        err => {
          console.error("ERROR: getDashboardListById", err);
          this.toasterService.error("Failed To Find Dashboard List", "Dashboard List");
          //this.router.navigate(["/"]);
        }
      )
  }
}
